import { getTokens } from '../tokens/localStorage';

export interface AuthHeaders {
  Authorization?: string;
  IdToken?: string;
}

export const authHeader = (): AuthHeaders => {
  const { accessToken, idToken } = getTokens();

  if (accessToken) {
    return { Authorization: accessToken, IdToken: idToken ?? undefined };
  }

  return {};
};

export const getAuthHeadersWithBearer = (): Record<string, string> => {
  const { accessToken, idToken } = getTokens();

  if (accessToken) {
    return {
      Authorization: `Bearer ${accessToken}`,
      IdToken: idToken ?? '',
    };
  }

  return {};
};

/** Auth headers with raw token only (no "Bearer " prefix). Use for APIs that expect token as-is. */
export const getAuthHeadersWithTokenOnly = (): Record<string, string> => {
  const headers = authHeader();
  const result: Record<string, string> = {};

  if (headers.Authorization) {
    result.Authorization = headers.Authorization;
  }

  if (headers.IdToken) {
    result.IdToken = headers.IdToken;
  }

  return result;
};
